function checkAccessCode(correctCode, url, csrfToken, event) {
    event.preventDefault();
    event.stopPropagation();

    const userCode = prompt("Veuillez entrer le code d'accès pour devenir membre :");

    if (userCode === correctCode) {
        var form = document.createElement('form');
        form.method = 'POST';
        form.action = url;

        var csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = 'authenticity_token';
        csrfInput.value = csrfToken;
        form.appendChild(csrfInput);

        document.body.appendChild(form);
        form.submit();
    } else {
        alert("Code incorrect");
    }
}

window.checkAccessCode = checkAccessCode;

const initDevenirMembre = () => {
    const btn = document.querySelector('#devenir-membre-btn');
    if (!btn) return;

    btn.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const code = prompt("Veuillez entrer le code d'accès pour devenir membre :");
        if (!code) return;

        const url = btn.dataset.url;
        const csrf = document.querySelector('meta[name="csrf-token"]').content;

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "X-CSRF-Token": csrf,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ code: code })
            });

            const json = await response.json();

            if (json.success) {
                alert("Votre demande de membre a bien été envoyée.");
                window.location.reload();
            } else {
                alert(json.error || "Code incorrect");
            }
        } catch (e) {
            console.error("Erreur lors de la requête :", e);
            alert("Erreur serveur.");
        }
    });
};

export { initDevenirMembre };


